import { application } from "./application"

// Esbuild doesn't support import.meta.glob, so we need to manually import controllers
// You can use esbuild plugins or import them explicitly here

// Example for manual imports:
import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AccountTypeController from "./account_type_controller"
application.register("account-type", AccountTypeController)

import SiretController from "./siret_controller"
application.register("siret", SiretController)

import IbanController from "./iban_controller"
application.register("iban", IbanController)

import LanguageSelectController from "./language_select_controller"
application.register("language-select", LanguageSelectController)

import LocaleTabsController from "./locale_tabs_controller"
application.register("locale-tabs", LocaleTabsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import BundleController from "./bundle_controller"
application.register("bundle", BundleController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ShrineUploadController from "./shrine_upload_controller"
application.register("shrine-upload", ShrineUploadController)

import TagPickerController from "./tag_picker_controller"
application.register("tag-picker", TagPickerController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ProductKindController from "./product_kind_controller"
application.register("product-kind", ProductKindController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import BoostPricingController from './boost_pricing_controller'
application.register('boost-pricing', BoostPricingController)

import HierarchicalSelectController from "./hierarchical_select_controller"
application.register("hierarchical-select", HierarchicalSelectController)

import MediaPickerController from "./media_picker_controller"
application.register("media-picker", MediaPickerController)

import AvailabilityCheckController from "./availability_check_controller"
application.register("availability-check", AvailabilityCheckController)

import ReservationPricingController from "./reservation_pricing_controller"
application.register("reservation-pricing", ReservationPricingController)

import StepperController from "./stepper_controller"
application.register("stepper", StepperController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import ImageCarouselController from "./image_carousel_controller"
application.register("image-carousel", ImageCarouselController)

import PhotoLightboxController from "./photo_lightbox_controller"
application.register("photo-lightbox", PhotoLightboxController)

import ListingCardController from "./listing_card_controller"
application.register("listing-card", ListingCardController)

import SearchBarLocationController from "./search_bar_location_controller"
application.register("search-bar-location", SearchBarLocationController)

import SearchBarDateRangeController from "./search_bar_date_range_controller"
application.register("search-bar-date-range", SearchBarDateRangeController)

import SearchBarGuestsController from "./search_bar_guests_controller"
application.register("search-bar-guests", SearchBarGuestsController)

import MessageFormController from "./message_form_controller"
application.register("message-form", MessageFormController)

import ConversationListController from "./conversation_list_controller"
application.register("conversation-list", ConversationListController)

import ScrollBottomController from "./scroll_bottom_controller"
application.register("scroll-bottom", ScrollBottomController)

import EquipmentMapController from "./equipment_map_controller"
application.register("equipment-map", EquipmentMapController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import PriceLabelController from "./price_label_controller"
application.register("price-label", PriceLabelController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
